import React from "react";

const SubmittedPage = ({ apiSections, answers, onGoToDashboard }) => {
  let yes = 0, no = 0, partial = 0, total = 0;

  apiSections
    .filter((sec) => sec.section !== "Report")
    .forEach((sec) => {
      (answers[sec.section] || []).forEach((a) => {
        total++;
        if (a.response === "yes")          yes++;
        else if (a.response === "no")       no++;
        else if (a.response === "partial")  partial++;
      });
    });

  const pct = (n) => (total === 0 ? 0 : Math.round((n / total) * 100));

  const stats = [
    { label: "Yes",     value: yes,     pct: pct(yes),     color: "#22c55e", bg: "#f0fdf4", border: "#bbf7d0" },
    { label: "No",      value: no,      pct: pct(no),      color: "#ef4444", bg: "#fef2f2", border: "#fecaca" },
    { label: "Partial", value: partial, pct: pct(partial), color: "#f59e0b", bg: "#fffbeb", border: "#fde68a" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "60px 24px", fontFamily: "'Segoe UI', Arial, sans-serif" }}>
      <div style={{ fontSize: "48px", marginBottom: "12px" }}>🎉</div>
      <div style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", marginBottom: "6px" }}>Assessment Submitted!</div>
      <div style={{ fontSize: "13px", color: "#64748b", marginBottom: "40px" }}>Here's a breakdown of your responses across all sections</div>

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center", marginBottom: "40px", width: "100%", maxWidth: "720px" }}>
        {stats.map(({ label, value, pct: p, color, bg, border }) => (
          <div key={label} style={{ flex: "1 1 180px", background: bg, border: `1.5px solid ${border}`, borderRadius: "14px", padding: "28px 24px", textAlign: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
            <div style={{ fontSize: "48px", fontWeight: "800", color, lineHeight: 1 }}>{p}%</div>
            <div style={{ fontSize: "14px", fontWeight: "700", color, marginTop: "8px", textTransform: "uppercase", letterSpacing: "0.08em" }}>{label}</div>
            <div style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>{value} of {total} questions</div>
            <div style={{ marginTop: "14px", height: "6px", borderRadius: "99px", background: border, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${p}%`, background: color, borderRadius: "99px" }} />
            </div>
          </div>
        ))}
      </div>

      <div style={{ width: "100%", maxWidth: "480px", height: "1px", background: "#e2e8f0", marginBottom: "36px" }} />

      <button
        onClick={onGoToDashboard}
        style={{
          background: "#bb1ccc",
          color: "white",
          border: "none",
          borderRadius: "6px",
          padding: "12px 36px",
          cursor: "pointer",
          fontWeight: "700",
          fontSize: "14px",
        }}
      >
        GO TO DASHBOARD
      </button>
    </div>
  );
};

export default SubmittedPage;